export class SpinnerConfig {
  strokeWidth: number;
  diameter: number;

  constructor(strokeWidth: number, diameter: number) {
    this.strokeWidth = strokeWidth;
    this.diameter = diameter;
  }
}
